// extracted by mini-css-extract-plugin
module.exports = {"report-container":"Reports_report-container__3ETml","add":"Reports_add__1Ss_8"};